import { render } from "./ScreenAnswerGG.vue?vue&type=template&id=865466b0&scoped=true&ts=true"
import script from "./ScreenAnswerGG.vue?vue&type=script&lang=ts"
export * from "./ScreenAnswerGG.vue?vue&type=script&lang=ts"

import "./ScreenAnswerGG.vue?vue&type=style&index=0&id=865466b0&scoped=true&lang=scss"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-865466b0"]])

export default __exports__